<template>
    <div>
        <div class="DivInfoData" ref="DivInfoData">
            Info recuperada de fecha: <span ref="FechaData"></span>

            <div class="fRight" v-on:click.stop="ObtenerDatos()">
                <font-awesome-icon
                    icon="sync-alt"
                    size="4x"
                    :style="{ color: 'white' }"
                    class="IconoActualizar fLeft"
                />
                <!-- Actualizar -->
                <div class="clear"></div>
            </div>

            <div class="clear"></div>
        </div>
        <table>
            <thead>
                <tr>
                    <th v-for="(titulo, index) in columnas" :key="index">
                        {{ titulo }}
                    </th>
                </tr>
            </thead>
            <!-- TODO:(!) Ajustar modelo de info para unificar tbody -->
            <tbody v-if="idHerramienta > 0">
                <tr
                    v-for="(registro, i) in Registros"
                    :key="i"
                    v-on:click="
                        VerRegistro(registro.IdHerramientaEstablecimiento)
                    "
                >
                    <td v-if="columnas.includes(ColumnasTabla.Productor)">
                        {{ registro.NombreProductor }}
                    </td>
                    <td v-if="columnas.includes(ColumnasTabla.Establecimiento)">
                        {{ registro.NombreEstablecimiento }}
                    </td>
                    <td v-if="columnas.includes(ColumnasTabla.Fecha)">
                        {{ registro.FechaAlta }}
                    </td>
                    <td v-if="columnas.includes(ColumnasTabla.Localidad)">
                        {{ registro.Localidad }}
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr
                    v-for="(registro, i) in Registros"
                    :key="i"
                    v-on:click="VerRegistro(registro._Id)"
                >
                    <td v-if="columnas.includes(ColumnasTabla.Productor)">
                        {{ registro._NombreProductor }}
                    </td>
                    <td v-if="columnas.includes(ColumnasTabla.Establecimiento)">
                        {{ registro._NombreEstablecimiento }}
                    </td>
                    <td v-if="columnas.includes(ColumnasTabla.Fecha)">
                        {{ registro._FechaAlta }}
                    </td>
                    <td v-if="columnas.includes(ColumnasTabla.Localidad)">
                        {{ registro._Localidad }}
                    </td>
                </tr>
            </tbody>
        </table>


        <div class="SinRegistros" v-if="!HaveRecords">
        Aún no hay registros...
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Clases from "../Auxiliares/Clases.js";
import { ColumnasTabla, Herramientas } from "../Auxiliares/Enums";

export default {
    props: {
        nombre: {
            type: String,
            required: true,
        },
        columnas: {
            type: Array,
            required: true,
        },
        idHerramienta: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            Registros: null,
            _UserOk: false,
            Error: null,
            ColumnasTabla,
        };
    },
    mounted() {
        this.RefreshInfo();
    },
    methods: {
        RefreshInfo() {
            //TODO: ver si chequeamos sesión acá o en un mixin
            this._UserOk = this.$parent.$parent.Datos.ChequearSesionUsuario(
                this.$router
            );
            if (this._UserOk) {
                this.IntentoObtenerDataDeCache();
                this.ObtenerDatos();
            }
        },
        ObtenerDatos() {
            var _This = this;
            try {
                let result;
                let idUsuario = this.$parent.$parent.Datos._User._ID;
                let firstPartUrl = `${this.urlPosts}/AgroIdeas`;
                let url = `${firstPartUrl}/GetHerramientaEstablecimiento/${idUsuario}/${this.idHerramienta}`;

                if (this.idHerramienta > 0) result = axios.get(url);
                else
                    result = axios.post(`${firstPartUrl}/${this.nombre}`, {
                        IdUsuario: idUsuario,
                    });

                result
                    .then(function (response) {
                        //console.log(response.data);
                        _This.Registros = response.data;
                        _This.GuardarDataEnCache(_This.Registros);
                        _This.$refs.DivInfoData.classList.remove("Visible");
                    })
                    .catch(function (error) {
                        _This.$refs.DivInfoData.classList.add("Visible");
                        //_This.IntentoObtenerDataDeCache();
                    })
                    .then(function () {});
            } catch (error) {
                console.log(error);
            }
        },
        VerRegistro(id) {
            let name = Object.keys(Herramientas).find(
                (key) => Herramientas[key].id == this.idHerramienta
            );
            if (this.idHerramienta > 0) {
                this.$router.push({
                    name: `Registros${name}`,
                    params: { Id: id },
                }); // `/${this.$router.currentRoute.path}/` + id);
            } else {
                this.$router.push(`/${this.nombre}/` + id);
            }
        },
        IntentoObtenerDataDeCache() {
            var _Data = Clases.RecuperarJsonDeStorage(this.KeyDataCacheada());
            if (_Data != null) {
                this.Registros = _Data._Json;
                this.$refs.FechaData.innerHTML = _Data._Fecha._FechaYHora;
            }
        },
        GuardarDataEnCache(_InfoAGuardar) {
            var _Data = {
                _Fecha: new Clases.Fecha(new Date()),
                _Key: this.KeyDataCacheada(),
                _Json: _InfoAGuardar,
            };
            Clases.GuardarJsonEnStorage(this.KeyDataCacheada(), _Data);
        },
        KeyDataCacheada() {
            return `Info_${this.$router.currentRoute.name}_${this.$parent.$parent.Datos._User._ID}`;
        },
    },
    computed:{
        HaveRecords(){
            if (this.Registros == null) return false;
            return this.Registros.length;
        }
    },
    watch: {
        idHerramienta: function (newValue, oldValue) {
            this.RefreshInfo();
        },
    },
};
</script>
